





































import { Vue } from 'vue-property-decorator'
import { CIcon } from '@coreui/icons-vue'
import ScreenTile from '../components/ScreenTile.vue'
import * as powerbi from 'powerbi-client'
import { cisStar, cilStar } from '@coreui/icons-pro'

interface IToken {
  description: string
  embedUrl: string
  id: string
  name: string
  token: {
    expiration: string
    token: string
    tokenId: string
  }
}

export default Vue.extend({
  props: {
    reportId: {
      required: true,
      type: String,
    },
    reportName: {
      required: true,
      type: String,
    },
    favorite: {
      required: false,
      type: Boolean,
    },
  },
  data: function (): {
    loading: boolean
    favoritedStarIcon: any[]
    standardStarIcon: any[]
    favoriteOverride: boolean | undefined
    detailedError: string | undefined
  } {
    return {
      loading: true,
      favoritedStarIcon: cisStar,
      standardStarIcon: cilStar,
      favoriteOverride: undefined as boolean | undefined,
      detailedError: undefined,
    }
  },
  computed: {
    favoriteStatus: function (): boolean {
      if (this.favoriteOverride !== undefined) {
        return this.favoriteOverride
      }
      return this.favorite
    },
  },
  components: { ScreenTile, CIcon },
  methods: {
    toggleFavorite: async function () {
      if (!this.favoriteStatus) {
        await fetch('/api/favorites', {
          method: 'POST',
          body: JSON.stringify({
            reportId: this.reportId,
            reportName: this.reportName,
          }),
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        })
        this.favoriteOverride = true
      } else {
        await fetch(`/api/favorites/reports/${this.reportId}`, {
          method: 'DELETE',
        })
        this.favoriteOverride = false
      }
    },
  },
  mounted: async function () {
    const tokenRequest = await fetch(`/api/reports/${this.reportId}`)
    if (tokenRequest.ok) {
      const token = (await tokenRequest.json()) as IToken

      const permissions = powerbi.models.Permissions.All
      const config = {
        visualName: '',
        type: 'report',
        accessToken: token.token.token, // I'm not changing this, it's awesome
        embedUrl: token.embedUrl,
        tokenType: powerbi.models.TokenType.Embed,
        permissions,
        settings: {
          panes: {
            filters: {
              visible: true,
            },
            pageNavigation: {
              visible: true,
            },
          },
        },
      }

      // Embed the report and display it within the div container
      const embedder = new powerbi.service.Service(
        powerbi.factories.hpmFactory,
        powerbi.factories.wpmpFactory,
        powerbi.factories.routerFactory
      )

      const el = document.querySelector('#reportdiv') as HTMLElement
      if (el) {
        embedder.embed(el, config)
      }
    } else {
      const message = JSON.parse(await tokenRequest.text())
      this.detailedError = message.powerBIErrorMessage
    }
    this.loading = false
  },
})
